import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TheCrypt} from "../../TheCrypt";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCryptGameMode} from "../../server/TheCryptGameMode";
import {DropInPresentation} from "../../presentations/maingame/DropInPresentation";
import {FillUpPresentation} from "../../presentations/maingame/FillUpPresentation";

export class TheCryptFSResultPresentation implements FlowStatePresentation {

    public start(flowStateController:FlowStateController):void {
        const presentations:SimplePresentation[] = [];
        if (TheCrypt.model.data.mode == TheCryptGameMode.FREESPIN){
            //presentations.push(new LocalPresentation((controller:SimplePresentationRunnerController)=>this.checkLocksAndXBet(controller), ()=>true, "checkLocksAndXBet"));
            presentations.push(new DropInPresentation());
        } else if (TheCrypt.model.data.mode == TheCryptGameMode.FREESPIN_AVALANCHE) {
            presentations.push(new FillUpPresentation());
        }

        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback));
    }
}